/**
 * Photothèque Minds' Academy — légendes des photos (Biblio).
 */

export const PHOTO_GROUPS = [
  {
    id: 'formations',
    kicker: 'En classe',
    title: 'Nos formations',
    intro: 'Ce sont nos séances auprès des étudiants : on enseigne, on accompagne, on avance ensemble.',
    photos: [
      {
        src: '/phototheque/formation-classe.jpg',
        alt: "Séance de formation Minds' Academy en salle informatique",
        title: 'Formation en salle',
        caption: "Nos étudiants en séance pratique, chacun sur son laptop — c'est ainsi que Minds' Academy donne ses formations.",
      },
      {
        src: '/phototheque/formation-etudiants.jpg',
        alt: "Étudiants concentrés pendant un cours Minds' Academy",
        title: 'Au plus près des étudiants',
        caption: 'Un cours encadré, à taille humaine : on explique, on corrige, on avance au rythme de la classe.',
      },
      {
        src: '/phototheque/formation-groupe.jpg',
        alt: "Le fondateur Ouday Benabid avec un groupe d'étudiants en fin de séance",
        title: 'Après la séance',
        caption: "Fin de formation avec le groupe : le travail en classe, et l'esprit d'équipe qui va avec.",
      },
      {
        src: '/phototheque/formation-equipe.jpg',
        alt: "Groupe d'étudiants Minds' Academy dans une salle de cours",
        title: 'Une promo, une salle',
        caption: "Les formations Minds' Academy, c'est aussi ces moments de groupe — concentrés, puis complices.",
      },
    ],
  },
  {
    id: 'monaco',
    kicker: 'Monaco',
    title: 'Expérience internationale',
    intro: "Ouday Benabid, fondateur de Minds' Academy, porte aussi une expérience edtech à Monaco — jusqu'aux plus hautes autorités de la Principauté.",
    photos: [
      {
        src: '/phototheque/monaco-demoday.jpg',
        alt: "Intervention à l'échelle internationale",
        title: "À l'échelle internationale",
        caption: "Des interventions menées à l'international — des prises de parole au cœur des écosystèmes d'innovation, au-delà des salles de classe.",
      },
      {
        src: '/phototheque/monaco-ministres-demo.jpg',
        alt: 'Ouday Benabid présente son projet à Christophe Mirmand et Frédéric Cottalorda',
        title: "Avec le Ministre d'État",
        caption: "Présentation à M. Christophe Mirmand, Ministre d'État de Monaco, et à M. Frédéric Cottalorda, Conseiller de Gouvernement-Ministre des Finances et de l'Économie.",
      },
      {
        src: '/phototheque/monaco-ministres-echange.jpg',
        alt: "Échange d'Ouday Benabid avec Christophe Mirmand et le ministre de l'Économie",
        title: 'Échange à MonacoTech',
        caption: "Rencontre avec M. Christophe Mirmand, Ministre d'État, et M. Frédéric Cottalorda, ministre de l'Économie et des Finances — une reconnaissance de l'expertise éducative portée depuis Monaco.",
      },
    ],
  },
]
